import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  margin-top: 35px;
`;

export default Container;
